export default "__VITE_ASSET__DkRXIKRs__"